<div>
  <progress-busy *ngIf="loading"></progress-busy>
  <div class="container">
    <div class="configurations-container">
      <div class="configurations-header">
        <a [style]="headerStyle">
          {{ username | initials }}
        </a>
      </div>
      <div class="configurations-body">
        <mat-form-field>
          <mat-label>{{ "labels.loggedAs" | translate }}</mat-label>
          <input readonly [value]="username" matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "labels.account" | translate }}</mat-label>
          <mat-select [value]="selectedAccount" (selectionChange)="handleAccountSelectionChange($event)">
            <mat-option *ngFor="let account of accounts" [value]="account">
              {{ account?.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "labels.language" | translate }}</mat-label>
          <mat-select [value]="selectedLanguage" (selectionChange)="handleLanguageSelectionChange($event)">
            <mat-option *ngFor="let language of languages" [value]="language">
              {{ language?.name | async }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="configurations-footer">
        <img src="../../../../assets/Images/Marca Institucional Promob-01.png" />

        <button mat-flat-button color="warn" (click)="logout()">{{ "actions.exit" | translate }}</button>
      </div>
    </div>
  </div>
</div>
